import type { LDFlagSet } from 'launchdarkly-js-client-sdk'

export const isAtLeastOneAccessFlagEnabled = (
  flags: LDFlagSet,
  accessFlags?: string[]
) =>
  accessFlags && accessFlags.length > 0
    ? accessFlags.some((flag) => flags[flag])
    : true
